import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import {getOneRosterSourcesByClass } from "../../../store/OneRoster/OneRosterClassAction";
import StatusCode from "../../../util/StatusCode";
import TableHorizontal from "../../misc/TableHorizontal";
import { useTranslation } from 'react-i18next';
import * as Helper from '../../../util/Helper';
import { RequestState } from '../../../models/RequestState';
import { OneRosterClassSource } from '../../../models/CoreOneRosterModels';
import { RootState } from "../../../store/store";



const OneRosterClassSources = () => {
    const { t } = useTranslation(['common', 'oneRoster']);
    const { eventId } = useParams();
    const dispatch = useDispatch();
    const sources = useSelector<RootState, RequestState<OneRosterClassSource[]>>(state => state.onerosterClass.sources);
    const [totalCount, setTotalCount] = useState(0)

    useEffect(() => {
        if (eventId !== undefined) {
            getOneRosterSourcesByClass(eventId)(dispatch); 
        }
    }, [dispatch, eventId]);

    useEffect(() => {
        if (sources.code === StatusCode.COMPLETE){
            setTotalCount(sources.data.length) 
        }
    },[sources])

    const mapClassSources = () => {
        if (sources.code !== StatusCode.COMPLETE) {
             return [];
        }
            return sources.data.map(x => ({
                id: x.id,
                data: [
                x.flowSyncType === 1 ? { value: <Link to={`/activity/${x.flowSyncActivityId}/information`}>{`${x.title}`}</Link> } : { value: <Link to={`/group/${x.flowSyncGroupId}/information`}>{`${x.title}`}</Link> },
                { value: Helper.activeText(x.active)},
                { value: Helper.active(x.master)},
                ]}));
            }

        const renderClassSources = () => {    
   
        return (
            <TableHorizontal
                header={[{ value: t('commonTableHeaders.title', { ns: 'oneRoster' })}, { value: t('commonTableHeaders.status', { ns: 'oneRoster' }) }, { value: t('commonTableHeaders.master', { ns: 'oneRoster' }) }]}
                info={mapClassSources()}
                displayName={t('commonTableHeaders.sources', { ns: 'oneRoster' })}
                noResMsg={t('notFound.sources', { ns: 'oneRoster' })}
                error={sources.code === StatusCode.ERROR}
                searching={sources.code === StatusCode.PENDING}
            />
        )
    }
    return (<>
                <div className="header_member_table large">{`${t('commonTableHeaders.sources', { ns: 'oneRoster' })} ${'('+totalCount+')'}`}</div>
        {renderClassSources()}
    </>
    );
}

export default OneRosterClassSources;
